import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setDependancies } from '../FormBuilderLibrary/slice';
import { checkAllConditions } from '../../utils/conditionalLogic';

const DependancyChecker = ({ formSchema, answers }) => {
	const dispatch = useDispatch();
	const reduxFormSchema = useSelector((state) => state?.form?.formSchema);
	const reduxAnswers = useSelector((state) => state?.form?.form);

	useEffect(() => {
		const schema = formSchema ? [formSchema] : reduxFormSchema;

		if (schema?.length > 0 && schema[0]) {
			let allInputs = [];
			schema?.forEach((e) => {
				e !== undefined && allInputs?.push(...e);
			});
			let dependancies = allInputs.filter((e) => e?.dependency);
			dispatch(setDependancies(dependancies));
		}
	}, [reduxFormSchema]);

	useEffect(() => {
		const allAnswers = answers ? [answers] : reduxAnswers;
		const schema = formSchema ? [formSchema] : reduxFormSchema;

		checkAllConditions(schema, allAnswers);
	}, [formSchema, answers, reduxAnswers, reduxFormSchema]);

	return <></>;
};

export default DependancyChecker;
